import React from "react";
import * as Sentry from "@sentry/react";
import { shallowEqual, useSelector } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { RootState } from "../setup";
import { ThemeProvider } from "../_start/layout/core";
import { MasterLayout } from "../_start/layout/MasterLayout";
import { Logout } from "./modules/auth/Logout";
import { PrivateRoutes } from "./routing/PrivateRoutes";
import { PublicRoutes } from "./routing/PublicRoutes";
import { ErrorsPage } from "./modules/errors/ErrorsPage";
import { SentryErrorBoundary } from "./components/error-tracking/SentryErrorBoundary";
import { updateSentryUserContext } from "./monitoring/sentry";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Sentry routing instrumentation for React Router v7.
const SentryRoutes = Sentry.withSentryReactRouterV7Routing(Routes);

const App: React.FC = () => {
	const isAuthorized = useSelector(
		(state: RootState) => state.auth.user,
		shallowEqual
	);

  React.useEffect(() => {
    updateSentryUserContext(isAuthorized);
  }, [isAuthorized]);

	return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <SentryErrorBoundary>
        <ThemeProvider>
          <ToastContainer hideProgressBar />

          <SentryRoutes>
            <Route path="/error/*" element={<ErrorsPage />} />
            <Route path="/logout" element={<Logout />} />
            {!isAuthorized ? (
              <Route path="/*" element={<PublicRoutes />} />
            ) : (
              <Route
                path="/*"
                element={
                  <MasterLayout>
                    <PrivateRoutes />
                  </MasterLayout>
                }
              />
            )}
          </SentryRoutes>
        </ThemeProvider>
      </SentryErrorBoundary>
    </BrowserRouter>
	);
};

const AppWithProfiler = Sentry.withProfiler(App, { name: "VerbondenAdminApp" });

export { AppWithProfiler as App };
